import { orderConstants } from "../constants";

export function orders(state = {}, action) {
  switch (action.type) {
    case orderConstants.GETALL_REQUEST:
      return {
        state,
        loading: true,
      };
    case orderConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false,
      };
    case orderConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function order(state = {}, action) {
  switch (action.type) {
    case orderConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      };
    case orderConstants.GET_SUCCESS:
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    case orderConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function orderPayments(state = {}, action) {
  switch (action.type) {
    case orderConstants.GET_PAYMENTS_REQUEST:
      return {
        state,
        loading: true,
      };
    case orderConstants.GET_PAYMENTS_SUCCESS:
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    case orderConstants.GET_PAYMENTS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function orderUpdate(state = {}, action) {
  switch (action.type) {
    case orderConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      };
    case orderConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false,
      };
    case orderConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}
